interface Props {
  message?: string;
}

export function Loader({ message }: Props) {
  return (
    <div className="min-h-screen bg-hit-black flex flex-col items-center justify-center gap-4">
      <div className="w-10 h-10 border-4 border-hit-gray-dark border-t-hit-gold rounded-full animate-spin" />
      {message && (
        <p className="text-hit-gray-mid text-sm text-center px-4">{message}</p>
      )}
    </div>
  );
}
